import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedArticles from './components/FeaturedArticles';
import PlatformRecommendations from './components/PlatformRecommendations';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedArticles />
        <PlatformRecommendations />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '约炮攻略 - 真实有效的约炮技巧与平台推荐',
            description: '约炮攻略汇集最实用的约炮技巧、平台选择与聊天话术，帮你快速找到志同道合的伴侣，提升约炮成功率。',
            url: 'https://pairfinder.github.io/',
            isPartOf: {
              '@type': 'WebSite',
              name: '约炮攻略',
              url: 'https://pairfinder.github.io/',
            },
          }),
        }}
      />
    </>
  );
}